import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';


@Component({
  selector: 'app-disbursement-reponse',
  templateUrl: './disbursement-reponse.component.html',
  styleUrls: ['./disbursement-reponse.component.css']
})
export class DisbursementReponseComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DisbursementReponseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  onClose(): void {
    this.dialogRef.close();
  }


}
